import { defineInlineEdit } from "../../../../../components/MobileList/inlineEdit";

/** views/jomla/jGroup/from submits the whole form, which is just `name`. */
export default defineInlineEdit({
  api: "jGroup",
  permission: "j_group_edit",
  hydrate: false,
  toPayload: (source) => ({ name: source.name ?? "" }),
  fields: {
    name: { label: "الاسم", type: "text", required: true },
  },
});
